import { forwardRef as w, createElement as T } from "react";
import { c as C } from "./client-COlxxEJZ.mjs";
import { jsx as l, jsxs as S } from "react/jsx-runtime";
import { c as g } from "./tw-cn-mXgPecoF.mjs";
import { T as I } from "./text-button-sAjANBk8.mjs";
import { c as N } from "./index-BpNK5r1N.mjs";
const k = N(["fixed w-full pointer-events-none"], {
  variants: {
    active: {
      true: "",
      false: ""
    },
    position: {
      bottom: "mx-auto left-1/2 bottom-0",
      top: "mx-auto left-1/2 top-20",
      center: "mx-auto left-1/2 top-1/2"
    }
  },
  compoundVariants: [
    // bottom과 top은 같은 애니메이션 사용
    {
      active: !0,
      position: ["bottom", "top"],
      className: "animate-toastFadeIn"
    },
    {
      active: !1,
      position: ["bottom", "top"],
      className: "animate-toastFadeOut"
    },
    // center는 별도의 opacity 애니메이션 사용
    {
      active: !0,
      position: "center",
      className: "animate-toastCenterFadeIn"
    },
    {
      active: !1,
      position: "center",
      className: "animate-toastCenterFadeOut"
    }
  ]
}), _ = N(
  ["inline-flex max-w-[320px] pc:max-w-[343px]", "bg-fill-neutral-main", "px-20 mb-20", "pointer-events-auto"],
  {
    variants: {
      radius: {
        "rounded-4": "rounded-4",
        "rounded-6": "rounded-6",
        "rounded-8": "rounded-8"
      },
      position: {
        bottom: "-translate-x-1/2",
        top: "-translate-x-1/2",
        center: "-translate-x-1/2 -translate-y-1/2"
      },
      hasTextButton: {
        true: "items-center gap-20 justify-between w-[calc(100%-32px)] max-w-none pc:w-[343px]",
        false: "text-center"
      },
      defaultVariants: {
        hasTextButton: !1
      }
    }
  }
), A = N([
  "text-static-white whitespace-pre-line",
  "typography-body-14-regular break-words line-clamp-2",
  "cursor-default select-none"
]), b = 9999, y = w(
  ({
    active: a,
    children: t,
    radius: e = "rounded-8",
    bottomOffset: i = 0,
    position: n = "bottom",
    textButton: s,
    onAnimationEnd: d = () => {
    },
    // 기본값 9999로 설정
    zIndex: r = b,
    rootContainerClass: p = ""
  }, u) => {
    const c = k({ active: a, position: n }), f = _({ radius: e, position: n, hasTextButton: !!s }), x = A({});
    return /* @__PURE__ */ l("div", { className: p, children: /* @__PURE__ */ l(
      "div",
      {
        className: c,
        onAnimationEnd: d,
        ref: u,
        style: { paddingBottom: `calc(env(safe-area-inset-bottom) + ${i})`, zIndex: r },
        children: /* @__PURE__ */ S("div", { className: g([f, e]), children: [
          /* @__PURE__ */ l("div", { className: "py-12", children: /* @__PURE__ */ l("span", { className: x, children: t }) }),
          !!s && /* @__PURE__ */ l(
            I,
            {
              className: "my-8 shrink-0",
              mobileSize: "small",
              onClick: s.onClick,
              pcSize: "small",
              theme: "underline",
              transparent: !0,
              children: s.text
            }
          )
        ] })
      }
    ) });
  }
);
y.displayName = "NDS.Toast";
const $ = "toast-container", o = [];
let m;
const B = ({
  id: a,
  className: t = "",
  duration: e = 3e3,
  clearOtherToast: i,
  zIndex: n = b,
  onAnimationEnd: s,
  ...d
}) => {
  const r = a || `toast_${Date.now()}`;
  let p;
  const u = E(r, t, n), c = C(u), f = (h) => {
    clearTimeout(p), c.unmount(), u.remove(), h || s == null || s(), F(v);
  }, x = () => {
    c.render(/* @__PURE__ */ T(y, { ...d, active: !0, key: r })), p = window.setTimeout(() => {
      c.render(/* @__PURE__ */ T(y, { ...d, active: !1, key: r, onAnimationEnd: f }));
    }, e);
  }, v = {
    toastKey: r,
    add: x,
    remove: f
  };
  return i && o.forEach(({ remove: h }) => {
    h();
  }), o.push(v), o.length === 1 && (m = o[0], x()), v;
};
function E(a, t, e) {
  const i = document.querySelector("body"), n = document.createElement("div");
  return n.className = `${$} ${a} ${t}`, n.style.position = "relative", n.style.zIndex = e.toString(), i.appendChild(n);
}
function F(a) {
  const t = o.findIndex((e) => e === a);
  if (o.splice(t, 1), o.length > 0) {
    const e = o[0];
    m = e, e.add();
  }
}
function V(a) {
  for (; o.length; ) {
    const t = o.shift();
    t == null || t.remove(a);
  }
  m == null || m.remove(a);
}
export {
  b as M,
  y as T,
  V as c,
  B as s
};
